import { useEffect, useState } from "react";
import api from "../api";
import { useLocation, useNavigate } from "react-router-dom";

const categories = [
"salaires","electricite","eau","impots",
"salubrite","maintenance","carburant","autres"
];

export default function AjouterDepense({ onSuccess }) {

const [form, setForm] = useState({
montant: "",
categorie: "salaires",
description: "",
mode_paiement: "cash"
});

const [personnel, setPersonnel] = useState([]);
const [selectedEmployeId, setSelectedEmployeId] = useState(null);
const [periodeAuto, setPeriodeAuto] = useState("");
const [charCount, setCharCount] = useState(0);

const location = useLocation();
const navigate = useNavigate();

useEffect(() => {
fetchPersonnel();
}, []);

const fetchPersonnel = async () => {
try {
const res = await api.get("/personnel");
setPersonnel(res.data);
} catch (err) {
console.error(err);
}
};

// 🔥 RÉCUPÉRATION NAVIGATION (SalairesList)
useEffect(() => {
if (location.state?.employeId) {
setSelectedEmployeId(Number(location.state.employeId));
}

if (location.state?.periode) {
  setPeriodeAuto(location.state.periode);

  // 🔒 verrou catégorie salaire
  setForm(prev => ({
    ...prev,
    categorie: "salaires"
  }));
}

}, [location]);

// 🔥 FETCH AUTO (si pas déjà fourni)
useEffect(() => {
if (selectedEmployeId && !location.state?.periode) {
fetchNextPeriode(selectedEmployeId);
}
}, [selectedEmployeId]);

const fetchNextPeriode = async (id) => {
try {
const res = await api.get(`/depenses/next-periode/${id}`);
setPeriodeAuto(res.data.periode);
} catch (err) {
console.error(err);
}
};

const handleChange = (e) => {
setForm({ ...form, [e.target.name]: e.target.value });

if (e.target.name === "description") {
  setCharCount(e.target.value.length);
}


};

// 🔥 Sélection employé + préremplissage salaire
const handleSelectEmploye = (e) => {
const id = Number(e.target.value);
setSelectedEmployeId(id);

const employe = personnel.find(p => p.id === id);

if (employe) {
  const salaire =
    employe.salaire ??
    employe.salaire_mensuel ??
    employe.montant ??
    employe.montant_salaire ??
    employe.salaire_base ??
    "";

  if (salaire) {
    setForm(prev => ({
      ...prev,
      montant: salaire
    }));
  }
}

};

const formatPeriode = (periode) => {
if (!periode) return "";
const [year, month] = periode.split("-");
const date = new Date(year, month - 1);
return date.toLocaleString("fr-FR", {
month: "long",
year: "numeric"
});
};

const handleSubmit = async (e) => {
e.preventDefault();

if (form.categorie === "salaires") {

  if (!selectedEmployeId) {
    return alert("Veuillez sélectionner un employé");
  }

  if (!periodeAuto) {
    return alert("Période introuvable");
  }

  const confirm1 = window.confirm(`Payer salaire ${formatPeriode(periodeAuto)} ?`);
  if (!confirm1) return;

  const confirm2 = window.confirm("⚠️ Cette action est définitive. Continuer ?");
  if (!confirm2) return;
}

if (
  form.categorie !== "salaires" &&
  (!form.description || form.description.trim().length < 3)
) {
  return alert("Description obligatoire (min 3 caractères)");
}

try {
  const finalForm = {
    ...form,
    personnel_id: selectedEmployeId || null,
    periode_salaire: form.categorie === "salaires" ? periodeAuto : null
  };

  await api.post("/depenses", finalForm);

  alert("Dépense enregistrée");

  setForm({
    montant: "",
    categorie: "salaires",
    description: "",
    mode_paiement: "cash"
  });

  setSelectedEmployeId(null);
  setPeriodeAuto("");
  setCharCount(0);

  if (onSuccess) onSuccess();

} catch (err) {
  console.error(err);
  alert("Erreur lors de l'enregistrement");
}

};

return ( <div className="p-4 max-w-xl mx-auto">

  <form onSubmit={handleSubmit} className="space-y-4">

    {/* 🔥 TITRE PRO */}
    <h3 className="text-xl font-bold text-center">
      {form.categorie === "salaires"
        ? `Paiement salaire ${formatPeriode(periodeAuto)}`
        : "Ajouter une dépense"}
    </h3>

    <input
      type="number"
      name="montant"
      placeholder="Montant"
      value={form.montant}
      onChange={handleChange}
      className="w-full border rounded-xl p-3"
      required
    />

    <select
      name="categorie"
      value={form.categorie}
      onChange={handleChange}
      disabled={!!location.state?.periode}
      className="w-full border rounded-xl p-3"
    >
      {categories.map(c => <option key={c}>{c}</option>)}
    </select>

    {/* SALAIRES */}
    {form.categorie === "salaires" && (
      <>
        <select
          value={selectedEmployeId || ""}
          onChange={handleSelectEmploye}
          className="w-full border rounded-xl p-3"
        >
          <option value="">-- Sélectionner un employé --</option>
          {personnel.map(p => (
            <option key={p.id} value={p.id}>
              {p.nom} {p.prenom}
            </option>
          ))}
        </select>

        {periodeAuto && (
          <div className="bg-gray-100 p-3 rounded-xl text-center">
            Période : <b>{formatPeriode(periodeAuto)}</b>
          </div>
        )}
      </>
    )}

    {/* AUTRES */}
    {form.categorie !== "salaires" && (
      <div>
        <textarea
          name="description"
          placeholder="Description (obligatoire)"
          value={form.description}
          onChange={handleChange}
          className="w-full border rounded-xl p-3"
          maxLength={30}
        />

        <div className="text-right text-sm text-gray-500">
          {charCount}/30 caractères
        </div>
      </div>
    )}

    <div className="flex gap-3">
      <button className="flex-1 bg-blue-600 text-white py-3 rounded-xl">
        Enregistrer
      </button>

      <button
        type="button"
        onClick={() => navigate(-1)}
        className="flex-1 bg-gray-400 text-white py-3 rounded-xl"
      >
        Annuler
      </button>
    </div>

  </form>

</div>

);
}
